export default __webpack_public_path__ + "static/media/landing.60d79e2c.png";